import angular from 'angular';
import { repeat } from 'lodash';

const DELAY = 500;

module.exports = angular.module('market.components.od-loading-text', [
])
.component('odLoadingText', {
  bindings: {
    text: '@?'
  },
  template: require('./od-loading-text.jade')(),
  controller: class {
    constructor($interval) {
      this.$interval = $interval;

      this.text = this.text || 'Loading';
      this.dots = '.';

      let count = 0;
      let update = () => {
        count++;
        this.dots = repeat('.', (count % 3) + 1);
      };

      this.intervalPromise = this.$interval(update, DELAY);
    }

    $onDestroy() {
      this.$interval.cancel(this.intervalPromise);
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-loading-text.js
 **/